import VectorPathPentagonIcon from "../images/VectorPathPentagonIcon.mjs";

/**
 * App icon for Perimeters
 * @see {GlyphIcon}
 * @see {VectorPathPentagonIcon}
 */
const AppPerimeterIcon = class extends VectorPathPentagonIcon {};

export default AppPerimeterIcon;